import * as React from 'react';

type props = {
  xwidth: string;
  backGroundColor: string;
};

const StackedBarChart: React.FunctionComponent<props> = ({ xwidth, backGroundColor }): JSX.Element => {
  const background = ' ' + backGroundColor.toString() + ' ';

  return (
    <div
      style={{ width: `${xwidth}` }}
      className={
        'text-monsterrat flex h-10 items-center justify-center border border-white text-center font-bold text-white' +
        background
      }
    >
      {parseInt(xwidth.replace('%', '')) > 10 ? xwidth : null}
    </div>
  );
};

export default StackedBarChart;
